<script>
import { mapGetters } from 'vuex'
import isEmpty from 'lodash.isempty'
import debounce from 'lodash.debounce'
import { Search } from '@/api'

const search = new Search()

export default {
    name: 'SearchControl',
    props: {
        value: null,
        searchValue: null,
        display: Boolean,
        loading: Boolean,
    },
    data() {
        return {
            active: false,
        }
    },
    computed: {
        search: () => search,
        ...mapGetters(['smDevice', 'isApple']),
    },
    methods: {
        onInput: debounce(function (e) {
            e.stopPropagation()
            let searchValue = e.target.value
            this.$emit('update:searchValue', searchValue)
            if (searchValue && searchValue.length) {
                this.$emit('update:loading', true)
                this.search.fetch(searchValue).then((result) => {
                    this.$emit('update:loading', false)
                    this.$emit('input', result)
                    this.$nextTick(() => {
                        if (!isEmpty(result)) this.$emit('open', e)
                    })
                })
            } else {
                this.clear()
            }
        }, 250),
        onClick(e) {
            if (this.display) {
                this.$emit('search', e)
            } else {
                this.active = true
                if (!isEmpty(this.value)) this.$emit('open', e)
            }
        },
        clear() {
            this.$emit('update:searchValue', null)
            this.$emit('input', {})
            this.$nextTick(() => {
                if (this.$refs.input) this.$refs.input.focus()
                // this.$emit('close')
            })
        },
        onBlur(e) {
            if (isEmpty(this.searchValue) && !e.relatedTarget?.classList.contains('clear'))
                this.active = false
        },
    },
}
</script>

<template lang="pug">
    form.form-control.search-control(@click="onClick" action="." :class="{'active': active, 'ml-4': !display && smDevice}")
        icon.icon(icon="fa-solid fa-search")
        .input.text-ellipsis(v-if="display") {{searchValue || $t('labels.placeholder.search') }}
        input.input.text-ellipsis(v-else
            :value="searchValue"
            @input="onInput"
            @keydown.enter.stop.prevent=""
            @keyup.enter.stop.prevent=""
            ref="input"
            maxlength="255"
            :placeholder="$t('labels.placeholder.search')"
            type="search"
            @blur="onBlur")
        transition(name="fade")
            button.btn.btn-icon.clear.btn-sm(v-if="(active || smDevice) && searchValue" @click.stop.prevent="clear" aria-label="clear")
                icon(icon="fa-solid fa-times")
</template>
